import React from 'react';
import { makeStyles } from '@lifeomic/chroma-react/styles';

const useStyles = makeStyles(theme => ({
  root: {},
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1.5),
  },
  detailText: {
    marginRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.subtitle1.fontSize,
  },
  detailDescription: {
    color: theme.palette.black[500],
    margin: 0,
  },
}));

export const DetailColumn = ({ columns, data }) => {
  const classes = useStyles({});

  if (!columns || !data) {
    return null;
  }

  return columns.map((c, i) => {
    const content = c.cell.content
      ? c.cell.content(data)
      : c.cell.valuePath && data[c.cell.valuePath];
    if (!content) {
      return null;
    }

    return (
      <div key={i} className={classes.detailRow}>
        <dt className={classes.detailText}>{c.header.label}</dt>
        <dd className={classes.detailDescription}>{content}</dd>
      </div>
    );
  });
};
